<div class="container isDesktop">
    <div class="row position-relative" >
        <div class="banner">
            <div>
                <!-- Carousel items -->
                <div class="carousel-inner">
                    <div class="carousel-item active" *ngFor="let item of items">
                        <img [src]="item.url" class="img-fluid" *ngIf="item.url">
                        <img src="assets/App_Themes/images/banner_mask.png" class="img-fluid" *ngIf="!item.url">
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="container isMobile">
    <div class="row">
        <div class="banner">
        <div>
            <!-- Carousel items -->
            <div class="carousel-inner">
                <div class="carousel-item active">
                    <img src="assets/App_Themes/images/banner/banner-sm_1.png" class="img-fluid">
                </div>
            </div>
        </div>
        </div>
    </div>
</div>